import { FieldLabel, TextInput } from '../../components/Primitives.jsx';
import { Segmented } from '../StepInspector.jsx';
import { ColSelect } from '../shared/ColSelect.jsx';

export function ProfileOutliersInspector({ step, onChange }) {
  const c = step.config || {};
  const u = (patch) => onChange({ ...step, config: { ...c, ...patch } });
  return (
    <div>
      <FieldLabel>Column</FieldLabel>
      <ColSelect value={c.column} onChange={(v) => u({ column: v })} />
      <FieldLabel>Method</FieldLabel>
      <Segmented value={c.method || 'iqr'} onChange={(v) => u({ method: v })}
        options={[
          { value: 'iqr', label: 'IQR ×1.5' },
          { value: 'zscore', label: 'Z-score >3' },
          { value: 'mad', label: 'MAD' },
        ]} />
      <FieldLabel>Output column</FieldLabel>
      <TextInput mono value={c.target ?? 'is_outlier'} onChange={(v) => u({ target: v })} />
    </div>
  );
}
